











































import { cloneDeep } from 'lodash'
import { Component, Prop, VModel, Watch } from 'vue-property-decorator'

import { PiningPartsHelper } from '../NewMultiMessageEditorWithMedia/types'
import MessageEditorPropsMixin from '../PropsMixin'
import { MediaEditorMode } from '../types'
import MessageBody from './Body/MessageBody.vue'
import SettingsMessageManager from './Body/logic/SettingsMessageManager'
import { IMessageSettings } from './Body/logic/types'
import ButtonsConstructor from './ButtonsConstructor/ButtonsConstructor.vue'
import ButtonsManager from './ButtonsConstructor/logic/ButtonsManager'
import MessageMedia from './Media/MessageMedia.vue'
import MediaManager from './Media/logic/MediaManager'
import { FileType } from './Media/types'
import MessageEditorWithMediaData from './types'

@Component({
  components: {
    MessageMedia,
    MessageBody,
    ButtonsConstructor,
  }
})
export default class MessageEditorWithMedia extends MessageEditorPropsMixin {
  @Prop() prefix!: string

  @VModel() message!: MessageEditorWithMediaData

  /** Эти параметры только для расширения возможностей MultiMessageEditor */
  @Prop() pinButtonsHelper?: PiningPartsHelper

  @Prop() pinMediaHelper?: PiningPartsHelper

  /**
   * Метод принимает в себя булево значение.
   * Срабатывает в начале и конце загрузки медиа файлов.
   * Позволяет выключить кнопки навигации для MultiMessageEditor
   * */
  @Prop() attachmentsIsLoadingCallback?: (val: boolean) => void
  /**--------------------------------------------------------------------------------*/

  mediaManager: MediaManager | null = null

  settingsMessageManager: SettingsMessageManager | null = null

  buttonsManager: ButtonsManager | null = null

  modelCopy: MessageEditorWithMediaData | null = null

  @Watch('availableButtonsTypes.length')
  onChange() {
    if (this.availableButtonsTypes && this.buttonsManager && this.modelCopy && this.modelCopy.buttons) {
      this.buttonsManager.updateBuildersList(this.modelCopy.buttons, this.availableButtonsTypes)
    }
  }

  updateModel(): void {
    if (this.modelCopy) {
      this.message = cloneDeep(this.modelCopy)
    }
  }

  initEditorMediaSettings(model: MessageEditorWithMediaData) {
    if (!this.targetToUpload) {
      console.error('targetToUpload prop is not provided')

      return
    }

    this.mediaManager = new MediaManager(model.attachments, this.targetToUpload, this.editorMode!, this.$i18n, this.customMediaTypes?.classParser)

    this.mediaManager.addOnUpdateHandler((attachments) => {
      if (this.modelCopy) {
        this.modelCopy.attachments = attachments

        if (this.settingsMessageManager) {
          this.settingsMessageManager.havePreviewMedia = attachments.some((a) => a.type === FileType.MessagePreview || a.type === FileType.TopMessagePreview)
        }

        this.updateModel()
      }
    })

    this.mediaManager.updateModel()

    if (this.attachmentsIsLoadingCallback) {
      this.mediaManager.addOnUploadFilesHandler(this.attachmentsIsLoadingCallback)
    }

  }

  created(): void {
    this.modelCopy = cloneDeep(this.message)

    if (this.hasMedia) {
      this.initEditorMediaSettings(this.modelCopy)
    }

    this.settingsMessageManager = new SettingsMessageManager(this.modelCopy)
    this.settingsMessageManager.addUpdateMessageSettingsListener(this.updateMessageSettings)
    this.settingsMessageManager.havePreviewMedia = this.modelCopy.attachments.some((a) => a.type === FileType.MessagePreview)

    if (this.availableButtonsTypes) {
      this.buttonsManager = new ButtonsManager(this.modelCopy.buttons,this.availableButtonsTypes)
      this.buttonsManager.addOnButtonsUpdateHandler((buttons) => {
        if (this.modelCopy) {
          this.modelCopy.buttons = buttons

          this.updateModel()
        }
      })
    }
  }

  updateMessageSettings(settings: IMessageSettings): void {
    if (this.modelCopy) {
      this.modelCopy.disable_link_preview = settings.disable_link_preview
      this.modelCopy.disable_notify = settings.disable_notify
      this.modelCopy.pin = settings.pin
      this.modelCopy.protect_content = settings.protect_content
      this.modelCopy.remove_after = settings.remove_after
      this.modelCopy.remove_previous = settings.remove_previous
      this.modelCopy.send_after = settings.send_after
      this.modelCopy.text = settings.text

      if (settings.topics) {
        this.modelCopy.topics = settings.topics
      }

      this.updateModel()
    }
  }

  updated(): void {
    const hasMessagePreview = this.message.attachments.some(attachment => attachment.type !== FileType.MessagePreview && attachment.type !== FileType.TopMessagePreview)

    if (this.message.attachments.length && this.editorMode === MediaEditorMode.TelegramShort && hasMessagePreview) {
      this.$emit('downgradeCounterMax')
    }
    if (this.message.attachments && this.message.attachments?.length > 0 && hasMessagePreview) {
      this.$emit('downgradeCounterMax')
    }
    if (!this.message.attachments?.length) {
      this.$emit('resetCounterMax')
    }
  }
}
